/**
 * Token 过期事件管理
 * 用于在 API 检测到 Token 过期时通知应用程序
 */

type TokenExpiredCallback = () => void;

class TokenExpiredEventManager {
    private listeners: Set<TokenExpiredCallback> = new Set();

    /**
     * 订阅 Token 过期事件
     */
    subscribe(callback: TokenExpiredCallback): () => void {
        this.listeners.add(callback);
        
        // 返回取消订阅函数
        return () => {
            this.listeners.delete(callback);
        };
    }

    /**
     * 触发 Token 过期事件
     */
    emit(): void {
        this.listeners.forEach((callback) => {
            try {
                callback();
            } catch (error) {
                console.error("Error in token expired callback:", error);
            }
        });
    }

    /**
     * 获取当前监听器数量（用于调试）
     */
    getListenerCount(): number {
        return this.listeners.size;
    }
}

// 导出单例
export const tokenExpiredEvent = new TokenExpiredEventManager();

// 开发环境下暴露到 window 对象，方便测试
if (process.env.NODE_ENV === 'development') {
    (window as any).__testTokenExpired = () => {
        tokenExpiredEvent.emit();
    };
}

